<template>
  <panel panel-class="scroll-horizontally shadows">
    <table class="table-field table-field-input">
      <thead>
        <tr>
          <th></th>
          <th
            v-for="column in columns"
            :key="column"
            :class="{ 'text-right': isNumericColumn(column) }"
          >
            {{ translatedColumnName(column) }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in allRows" :key="row">
          <td class="text-center">{{ rowIndex + 1 }}</td>
          <cell
            v-for="(column, columnIndex) in columns"
            :key="row + ':' + column"
            :column="column"
            :column-index="columnIndex"
            :row="row"
            :row-index="rowIndex"
            :last-column-index="columns.length - 1"
            :language="language"
            :default-language="defaultLanguage"
            :labels="labels"
            :disabled="disabled"
          >
          </cell>
          <td>
            <a
              v-if="dynamicRows.includes(row)"
              class="delete-row"
              @click.prevent="deleteRow(row)"
            >
              <span class="af-icons af-icons-close-circle"></span>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="dynamicRowsEnabled">
        <tr>
          <td></td>
          <td :colspan="columns.length">
            <a
              :class="[
                'btn',
                'btn-tertiary',
                'btn-xs',
                'add-row',
                { disabled: disabled }
              ]"
              @click.prevent="addDynamicRow"
            >
              {{ labels.addRow }}
            </a>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <input :id="id" v-model="tableFieldInput" type="hidden" :name="name" />
  </panel>
</template>

<script>
import { Panel } from 'vue-bootstrap';
import Cell from './TableFieldCell.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { createStore } from '../../store/modules/table-field';
import filtersMixin from './mixins/table-field-filters-mixin.js';
import translationsMixin from './mixins/table-field-translations-mixin.js';

export default {
  components: {
    Panel,
    Cell
  },
  mixins: [filtersMixin, translationsMixin],
  props: {
    id: {
      type: String,
      required: true
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    configurationTranslated: {
      type: Object,
      default: () => ({})
    },
    input: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      required: true
    },
    language: {
      type: String,
      default: 'en_GB'
    },
    defaultLanguage: {
      type: String,
      default: 'en_GB'
    },
    labels: {
      type: Object,
      default: () => ({
        addRow: 'Add row'
      })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState([
      'columns',
      'rows',
      'dynamicRowsEnabled',
      'dynamicRows',
      'translations'
    ]),
    ...mapGetters(['getInput']),
    tableFieldInput() {
      return JSON.stringify(this.getInput());
    },
    allRows() {
      return this.rows.concat(this.dynamicRows);
    }
  },
  watch: {
    tableFieldInput(newValue) {
      this.$emit('changed', newValue);
    },
    configuration() {
      this.setConfiguration(this.configuration);
    },
    configurationTranslated() {
      this.setTranslations(this.configurationTranslated);
    }
  },
  beforeCreate() {
    this.$store = createStore();
  },
  created() {
    this.setConfiguration(this.configuration);
    this.setTranslations(this.configurationTranslated);
    this.setInput(this.input);
  },
  methods: {
    ...mapMutations([
      'setConfiguration',
      'setTranslations',
      'setInput',
      'addDynamicRow',
      'deleteDynamicRow'
    ]),
    translatedColumnName(column) {
      return (
        this.getTranslation(this.language, column) ||
        this.getTranslation(this.defaultLanguage, column)
      );
    },
    deleteRow(row) {
      this.deleteDynamicRow(row);
      this.$emit('changed', JSON.stringify(this.getInput()));
    }
  }
};
</script>
